import React from 'react';

export const TopImage = ({
  footerTopImageUrl,
  footerTopImageAlt,
}: FooterTop) => {
  return (
    <div className="sm-down:overflow-hidden">
      <img
        className="-mb-[1px] bg-gray-100 block md:w-full object-cover w-[102%]"
        src={footerTopImageUrl}
        alt={footerTopImageAlt}
        loading="lazy"
      />
    </div>
  );
};
